const initialState = {
  // Getting Invoices Data
  isGettingInvoicesData: false,
  InvoicesDataList: [],
  chartYear: null,
  totalInvoices: 0,
  validInvoices: 0,
  invalidInvoices: 0,
  registeredBuyers: 0,
  unregisteredBuyers: 0,
  totalBuyers: 0,
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting InvoicesData List
    case "GET_INVOICES_REQUEST":
      return {
        ...state,
        isGettingInvoicesData: true,
      };
    case "GET_INVOICES_SUCCESS":
      return {
        ...state,
        isGettingInvoicesData: false,
        InvoicesDataList: action?.payload?.monthlyData || [],
        // The year the chart's months belong to (by invoice date).
        chartYear: action?.payload?.year || null,
        totalInvoices: action?.payload?.totalInvoice,
        validInvoices: action?.payload?.validInvoice,
        invalidInvoices: action?.payload?.inValidInvoice,
        registeredBuyers: action?.payload?.registeredBuyer,
        unregisteredBuyers: action?.payload?.unregisteredBuyer,
        totalBuyers: action?.payload?.registeredBuyer + action?.payload?.unregisteredBuyer,
      };
    case "GET_INVOICES_ERROR":
      return {
        ...state,
        isGettingInvoicesData: false,
      };
    default:
      return state;
  }
};

export default DashboardReducer;
